import { isStandalone } from "~/shared/lib/utils"
import { IconButton, IconButtonProps } from "~/shared/ui"

export function ReloadButton({ colorStyle, ...props }: Omit<IconButtonProps, "flat" | "icon" | "onClick">) {
	return isStandalone()
		&& <IconButton {...props} iconSize="2rem" className="mr-[1.25rem]"
					   transparent borderless
					   colorStyle={colorStyle || "primary"} icon="refresh"
					   onClick={() => location.reload()} />
}